export function EntitySectionDivider() {
  return (
    <div className="h-6 flex items-center">
      <hr className="w-full border-gray-300" />
    </div>
  );
}
